module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fm-title0"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_vm._v("The author dedicates this work to the many kind folks of Wikimedia Commons that contributed photographs for unlimited use with only appropriate credit required. The author would like to give a special note of appreciation to Alan Wilson, many of whose images grace this work.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13a0f472","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Dedication.vue
// module id = 60
// module chunks = 0